export default __webpack_public_path__ + "static/media/image20.25dd7eff.jpg";